import styles from './ErrorMessage.module.scss'

export const ErrorMessage = ({ text, customClass, isVisible }) => {
  return (
    <p
      className={`
				${styles.errorMessage} 
				${isVisible && styles['errorMessage--visible']} 
				${customClass}
			`}
    >
      {text}
    </p>
  )
}
